import React from 'react';
import dynamic from 'next/dynamic';

import { Initialize } from 'components/molecules/Initialize/Initialize';
import { PageAccess } from 'modules/shared/components/PageAccess';

type AppMainComponentProps = {
  children: React.ReactNode;
};

const EnvDetails = dynamic(() => import('modules/shared/components/EnvDetails'), {
  ssr: false,
});

/**
 * Main app-level component that wraps the main content of the application. This is mainly to make
 * testing of high-level components, such as EnvDetails, outside of next/app's App component and
 * context providers.
 */
export const AppMainComponent = ({ children }: AppMainComponentProps) => {
  const shouldRenderEnvDetails = ['dev', 'staging'].includes(process.env.APP_ENV || '');

  return (
    <>
      {shouldRenderEnvDetails && <EnvDetails />}
      {/* Wrap ErrorBoundary in Providers, mainly to grant access to ReduxStore due to PageBase */}
      <Initialize>
        <PageAccess>{children}</PageAccess>
      </Initialize>
    </>
  );
};
